module.exports = __webpack_public_path__ + "img/evals - grayscale.8a39257a.svg";